import Table from "@/shared/data-display/table";
import { usePersonsExtended } from "../model/use-persons-extended";
import { PersonLabel } from "../../person-label";
import { PersonSelectExtendedProps } from "./person-select-extended";
import { normalizeToArray } from "../utils/normalize-to-array";
import { PersonPositionAndOrganizationColumn } from "../../person-position-and-organization-column";
import { useTranslations } from "use-intl";

type PersonSelectExtendedTableProps = Pick<
  PersonSelectExtendedProps,
  "mode" | "value" | "onChange"
>;

export function PersonSelectExtendedTable({
  mode,
  onChange,
  value,
}: PersonSelectExtendedTableProps) {
  const t = useTranslations("PersonSelect");
  const { loading, persons, pagination } = usePersonsExtended();

  const isMultipleMode = mode === "multiple" || mode === "tags";
  const type = isMultipleMode ? "checkbox" : "radio";

  return (
    <Table
      rowSelection={{
        type,
        selectedRowKeys: normalizeToArray(value),
        // Берём ключи, а не записи: с preserveSelectedRowKeys antd сохраняет
        // выбор строк, которых нет в текущем dataSource (другая страница,
        // фильтр), и для них во втором аргументе приходит undefined.
        onChange: (selectedRowKeys) => {
          const ids = selectedRowKeys.map((key) => key.toString());

          isMultipleMode ? onChange?.(ids) : onChange?.(ids[0]);
        },
        preserveSelectedRowKeys: true,
      }}
      rowKey={(r) => r.id}
      loading={loading}
      dataSource={persons}
      pagination={pagination}
      columns={[
        {
          key: "name",
          title: t("Name"),
          render: (_, record) => <PersonLabel data={record} />,
        },
        {
          key: "personType",
          title: t("Person type"),
          render: (_, { personType }) => personType?.value.value,
        },
        {
          key: "department",
          title: t("Department"),
          render: (_, { position, organization }) => (
            <PersonPositionAndOrganizationColumn
              data={{ position, organization }}
            />
          ),
        },
      ]}
    />
  );
}
